export default {
    state: {
        show: false,
        confirmation: {}
    },

    mutations: {
        show(state, confirmation) {
            state.show = true
            state.confirmation = confirmation
        },
        hide(state) {
            state.show = false
            state.confirmation = {
                text: "",
                cancelCallback: null,
                okCallback: null
            }
        }
    },

    namespaced: true
}